import React from 'react';
import moment from 'moment-timezone';
import 'moment/locale/es';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faCalendarAlt, faUser, faBuilding, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import defaultConnect from '../../../components/redux/defaultConnect';
import makeRequest from '../../../lib/apiService';
import Confirmacion from '../../../components/confirmacion/confirmacion';
import VehiculosAsignados from './vehiculosAsignados/vehiculosAsignados';
import './styles.css';

moment.locale('es');

class DetallesChofer extends React.Component {
  state = {
    driver: {},
    user: null,
    showConfirmacion: false,
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const { setLoading, pushError, match: { params: { id } } } = this.props;
    try {
      setLoading(true);
      const driver = await makeRequest(
        `drivers/${id}`,
        { method: 'GET' },
      );
      this.setState({ driver }, () => {
        setLoading(false);
        if (driver.id_user) {
          this.getConcesionario(driver.id_user);
        }
      });
    } catch (error) {
      setLoading(false);
      pushError(error.message);
    }
  }

  getConcesionario = async (id) => {
    const { setLoading, pushError } = this.props;
    try {
      setLoading(true);
      const user = await makeRequest(
        `users/${id}`,
        { method: 'GET' },
      );
      this.setState({ user });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      pushError(error.message);
    }
  }

  deleteChofer = async () => {
    const { setLoading, pushError, pushSuccess, history } = this.props;
    const { driver } = this.state;
    try {
      this.setState({ showConfirmacion: false });
      setLoading(true);
      await makeRequest(`drivers/${driver.id_driver}`, { method: 'DELETE' });
      setLoading(false);
      pushSuccess('El chofer ha sido eliminado.', 3000);
      history.push('/panel/choferes');
    } catch (error) {
      setLoading(false);
      pushError(error.message);
    }
  }

  render() {
    const { driver, user, showConfirmacion } = this.state;
    const { match } = this.props;

    const avatarColors = ['#395FC2', '#2D9CDB', '#6FCF97', '#F2994A', '#EB5757', '#9B51E0', '#56CCF2'];
    const avatarColor = avatarColors[((driver.name || ' ').charCodeAt(0)) % avatarColors.length];
    const initials = `${(driver.name || '?')[0]}${(driver.last_name || '')[0]}`.toUpperCase();

    let statusBadge = null;
    switch (driver.disabled) {
      case true:
        statusBadge = <span className="badge badge-warning">Deshabilitado</span>;
        break;
      case false:
        statusBadge = <span className="badge badge-success">Activo</span>;
        break;
      default:
        statusBadge = <span className="badge badge-dark">N/A</span>;
        break;
    }

    return (
      <>
      <div className="detalles-chofer">

        <div className="driver-header">
          <div className="chofer-avatar-lg" style={{ backgroundColor: avatarColor }}>
            {initials}
          </div>
          <div className="driver-header-info">
            <p className="driver-name">{driver.name} {driver.last_name}</p>
            <p className="driver-meta">#{driver.id_driver} &nbsp;·&nbsp; {statusBadge}</p>
          </div>
          <div className="driver-header-actions">
            <Link className="btn btn-sm btn-sl-2" to={`/panel/choferes/chofer/${driver.id_driver}`}>
              <FontAwesomeIcon icon={faEdit} style={{ marginRight: '0.4rem' }} />
              Editar
            </Link>
            <button type="button" className="btn btn-sm btn-danger" onClick={() => this.setState({ showConfirmacion: true })}>
              <FontAwesomeIcon icon={faTrash} style={{ marginRight: '0.4rem' }} />
              Eliminar
            </button>
          </div>
        </div>

        <div className="row">

          <div className="col-12 section-divider">
            <span>Información</span>
          </div>

          <div className="col-12 col-md-4 dato">
            <p className="label">
              <FontAwesomeIcon icon={faPhone} />
              Teléfono
            </p>
            <p className={`value${!driver.phone_number ? ' muted' : ''}`}>
              {driver.phone_number || 'Sin registrar'}
            </p>
          </div>

          <div className="col-12 col-md-4 dato">
            <p className="label">
              <FontAwesomeIcon icon={faCalendarAlt} />
              Registro
            </p>
            <p className="value">
              {driver.createdAt ? moment(driver.createdAt).format('DD [de] MMMM [de] YYYY') : '—'}
            </p>
          </div>

          <div className="col-12 col-md-4 dato">
            <p className="label">
              <FontAwesomeIcon icon={faBuilding} />
              Concesionario
            </p>
            {user
              ? (
                <Link className="badge badge-primary" to={`/panel/concesionarios/concesionario/detalles/${driver.id_user}`}>
                  #{user.id_user} {user.name} {user.last_name}
                </Link>
              )
              : <p className="value muted">Sin concesionario asignado</p>
            }
          </div>

          <div className="col-12 section-divider">
            <span>Contacto de emergencia</span>
          </div>

          <div className="col-12 col-md-6 dato">
            <p className="label">
              <FontAwesomeIcon icon={faUser} />
              Nombre
            </p>
            <p className={`value${!driver.emergency_contact_name ? ' muted' : ''}`}>
              {driver.emergency_contact_name || 'Sin registrar'}
            </p>
          </div>

          <div className="col-12 col-md-6 dato">
            <p className="label">
              <FontAwesomeIcon icon={faPhone} />
              Teléfono
            </p>
            <p className={`value${!driver.emergency_contact_phone ? ' muted' : ''}`}>
              {driver.emergency_contact_phone || 'Sin registrar'}
            </p>
          </div>

        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          <VehiculosAsignados id={match.params.id} idUser={driver.id_user} />
        </div>
      </div>

      {showConfirmacion && (
        <Confirmacion
          message="El chofer será eliminado completamente del sistema."
          accept={this.deleteChofer}
          cancel={() => this.setState({ showConfirmacion: false })}
        />
      )}
      </>
    );
  }
}

export default defaultConnect(DetallesChofer);
